import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Setting = () => import("../components/content/settings/setting");
const EditAdmin = () => import("../components/content/settings/editAdmin");
const AddAdmin = () => import("../components/content/settings/addAdmin");

export const settingRoute = {
  path: "/settings",
  component: Setting,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
export const editAdminRoute = {
  path: "/edit-admin/:id",
  component: EditAdmin,
   // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
export const addAdminRoute = {
  path: "/add-admin",
  component: AddAdmin,
   // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
